"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thousandsConvert = thousandsConvert;
exports.thousandsConvertToFixed4 = thousandsConvertToFixed4;
// 年月日
function thousandsConvert(value, toFixed, showAllFlag) {
  if (toFixed === 0) value = parseInt(value).toFixed(0);else if (toFixed) value = parseFloat(value).toFixed(toFixed);else value = parseFloat(value).toFixed(2);
  if (typeof showAllFlag == 'undefined') {
    showAllFlag = true;
  }
  // var result = ''; // 存储格式化的结果
  // var j = 0; // 控制每3位加一个逗号
  // let flag = false
  // for (var i = value.length - 1; i >= 0; i--) {
  //   // 从末尾开始遍历到第一个
  //   j++;
  //   result = value[i] + result;
  //   if (value[i] === '.') {
  //     // 逗号只加在整数部分
  //     j = 0;
  //     flag = true
  //   }
  //   if (j === 3 && flag) {
  //     // 金额的最后一个数字正好满足3位时或者是负数，其前面不用加逗号，例:500.00
  //     if (i !== 0 && value[i - 1] !== '-') {
  //       result = ',' + result;
  //     }
  //     j = 0;
  //   }
  // }
  // return result;

  var flag = false;
  var result = '';
  var j = 0;
  for (var i = value.length - 1; i >= 0; i--) {
    if (!showAllFlag && value[i] !== '0' && value[i] !== '.') {
      showAllFlag = true;
    }
    j++;
    if (showAllFlag) {
      result = value[i] + result;
    }
    if (value[i] === '.') {
      flag = true;
      showAllFlag = true;
      j = 0;
    }
    if (j === 3 && flag) {
      if (i !== 0 && value[i - 1] !== '-') {
        result = ',' + result;
      }
      j = 0;
    }
  }
  return result;
}
// 年月日
function thousandsConvertToFixed4(value) {
  value = parseFloat(value).$toFixed(4);
  var result = ''; // 存储格式化的结果
  var j = 0; // 控制每3位加一个逗号
  for (var i = value.length - 1; i >= 0; i--) {
    // 从末尾开始遍历到第一个
    j++;
    result = value[i] + result;
    if (i > value.length - 6) {
      // 逗号只加在整数部分
      j = 0;
    }
    if (j === 3) {
      // 金额的最后一个数字正好满足3位时或者是负数，其前面不用加逗号，例:500.00
      if (i !== 0 && value[i - 1] !== '-') {
        result = ',' + result;
      }
      j = 0;
    }
  }
  return result;
}